<template>
    <section class="ui-user-bar">
        <section class="ui-user-bar-container">
            <div class="box-user">
                <div class="user-avatar">
                    <ui-image
                        :src="getImgCDN(userState?.photo)"
                        alt="busque"
                        design="border
                        circle"
                        w="80"
                        h="80" />
                </div>

                <div class="user-infos">
                    <div class="msg">Bem vindo</div>
                    <div class="name">
                        {{ userState?.first_name }}
                        <button type="button" @click="oldPanelLinkButton('perfil')">
                            <i class="fal fa-cog"/> Editar Perfil
                        </button>
                    </div>

                    <div class="points">
                        <div v-if="showPoints" class="total"> {{ points }} <small>pontos</small></div>
                        <div v-if="tasksCounter" class="task-resume">
                            <a :href="taskListLinkComputed">
                                Você tem <strong> {{ tasksCounter }} tarefas </strong> pendentes
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="search-enterprise">
                <ui-search
                    title="Buscar Empreendimentos"
                    placeholder="Digite o nome do empreendimento"
                    service="product"
                />

                <div class="last-login">
                    <i class="fal fa-calendar" />
                    Seu último acesso foi em {{ userState?.last_login | moment('DD/MM/YYYY [às] HH:mm') }}
                </div>
            </div>
        </section>
    </section>
</template>

<script>
    import { uiImage, uiSearch }   from '@/components/ui'
    import { mapGetters } from 'vuex'
    import helpers from '@/mixins/helpers'

    import { storage } from '@/services/storage'
    import { user } from '@/services/axios'

    export default {
        name: 'dash-user-bar',

        components: { uiImage, uiSearch },

        mixins: [helpers],

        data() {
            return {
                showPoints: false,
                points: 0,
                tasksCounter: 0
            }
        },

        computed: {
            ...mapGetters('auth', {
                userState: 'getUser',
            }),
            /**
             * Computed property que retorna  link para a lista de tarefas
             */
            taskListLinkComputed() {
                return this.oldPanelLink('vendas/clientes/tarefas')
            }
        },

        created() {
            this.checkPoints()
            this.$root.$on("total-task", total => {
                this.tasksCounter = total
            })

            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                /** Atualiza os pontos de clube sempre que o estado do usuário muda */
                if (mutation.type === 'SET_USER') {
                    this.checkPoints()
                }
            })
        },

        beforeDestroy() {
            // Desubscreve para a mutation
            this.unsubscribe()
        },


        methods: {
            checkPoints() {
                let clubPoints  = storage.get('club')
                clubPoints      = JSON.parse(clubPoints)

                if (clubPoints.status === 'active') this.showPoints = true

                if (this.userState) {
                    user.getPoints(this.userState.id).then(response => {
                        this.points = response.data.value
                    })
                }
            },
        }
    };

</script>


<style lang="stylus" scoped>
    @import 'styles.styl'
</style>